import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';
import { Psa, PsaType } from './psa.model';


export const HISTORY_PSA_ENDPOINT = 'history';
export const HISTORY_PSA_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(HISTORY_PSA_ENDPOINT);


export const historyPsaStateConfig: SignalStoreConfig<QueryState<Psa>> = {
    initState: {
      list: []
    }
  }


export const LISTA_HISTORY_PSA_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'id',
    field: 'id',
    primaryKey: true,
   type:'text'
  },
  {
    name: 'fromStatus',
    label: 'Dallo Stato',
    field: 'fromStatus',
    type:'text'
  },
    {
    name: 'toStatus',
    label: 'Allo Stato',
    field: 'toStatus',
    type:'text'
  },
  {
    name: 'createdAt',
    label: 'Ultima Modifica',
    field: 'createdAt',
    type:'datetime'
  },

];

export const LISTA_HISTORY_PSA_VISIBLECOLUMNS = [

  'fromStatus',
  'toStatus',
  'createdAt',
  'azioni'
];

